import { Fragment, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Disclosure } from '@headlessui/react';
import { Bars3Icon, XMarkIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import categories from '../products';
import logoJm from '../images/logo_jm.png';

const navigation = [
  { name: '3D Print Service', href: '/3d-print-service' },
  { name: 'Recensies', href: '/recensies' },
  { name: 'Over Ons', href: '/over-ons' },
  { name: 'Contact', href: '/contact' },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Navbar({ isMenuOpen, setIsMenuOpen }) {
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) {
      navigate(`/categorie/portretten?zoek=${encodeURIComponent(search)}`); // evt. aanpassen voor echte zoekfunctie
    }
  };

  return (
    <>
      <Disclosure as="nav" className="shadow" style={{ background: 'var(--color-bg)' }}>
        {({ open }) => (
          <>
            <div className="container-custom flex h-16 items-center justify-between px-2 sm:px-4">
              {/* Logo */}
              <div className="flex items-center flex-shrink-0">
                <Link to="/" className="flex items-center" style={{ textDecoration: 'none' }}>
                  <img src={logoJm} alt="Prints by Jeroen logo" className="h-8 w-auto sm:h-10" style={{ marginRight: 12 }} />
                </Link>
              </div>
              {/* Zoekbalk */}
              <form onSubmit={handleSearch} className="hidden sm:flex flex-1 justify-center mx-4">
                <div className="relative w-full max-w-lg">
                  <input
                    type="text"
                    placeholder="Waar ben je naar op zoek?"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    className="w-full rounded-full border border-grey px-4 py-2 focus:outline-none focus:ring-2 focus:ring-accent1 bg-white text-base"
                    style={{ color: 'var(--color-text)' }}
                  />
                  <button type="submit" className="absolute right-2 top-1/2 -translate-y-1/2 text-accent1">
                    <MagnifyingGlassIcon className="h-5 w-5" />
                  </button>
                </div>
              </form>
              {/* Desktop navigatie */}
              <div className="hidden sm:flex items-center space-x-4">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="px-3 py-2 rounded-md text-sm font-medium hover:text-accent1 transition"
                    style={{ color: 'var(--color-text)' }}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
              {/* Hamburger menu voor mobiel */}
              <div className="flex sm:hidden">
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-accent1 hover:bg-accent1 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-accent1">
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
            </div>
            {/* Mobiele zoekbalk en navigatie */}
            <Disclosure.Panel className="sm:hidden px-4 pb-2">
              <form onSubmit={handleSearch} className="flex w-full justify-center mb-2">
                <div className="relative w-full max-w-lg">
                  <input
                    type="text"
                    placeholder="Waar ben je naar op zoek?"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    className="w-full rounded-full border border-grey px-4 py-2 focus:outline-none focus:ring-2 focus:ring-accent1 bg-white text-base"
                    style={{ color: 'var(--color-text)' }}
                  />
                  <button type="submit" className="absolute right-2 top-1/2 -translate-y-1/2 text-accent1">
                    <MagnifyingGlassIcon className="h-5 w-5" />
                  </button>
                </div>
              </form>
              <div className="flex flex-col gap-2 mt-2">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.href}
                    className="px-3 py-2 rounded-md text-base font-medium hover:text-accent1 transition"
                    style={{ color: 'var(--color-text)' }}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </>
  );
} 